import { onAuthStateChanged, signOut } from 'firebase/auth'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { auth } from '../firebase'
import Footer from './Footer'
import Header from './Header'
import './Terms.css'
import { login } from './utility'


function Terms() {
    const [userAuth, setUserAuth] = useState([])
    useEffect(() => {

        onAuthStateChanged(auth, user => {
            if (user) {

                setUserAuth(user)
            } else {
                setUserAuth(null)
            }
        })

    }, [])
    const loginUser = () => login(userAuth)

    const logout = () => {
        return signOut(auth)
    }

    return (
        <div className='terms'>
            <Header login={loginUser} logout={logout} user={userAuth} />
            <main className='terms_main'>
                <div>
                    <h1>
                        Terms and Conditions
                    </h1>
                    <p>
                        Please read these Terms and Conditions carefully before using the Service.
                    </p>
                </div>
                <article>
                    <h2>
                        Subscriptions
                    </h2>
                    <p>
                        This service runs on a subscription based model. You will be billed in advance on a recurring and periodic basis ("Billing Cycle"). Currently Billing cycle is set to 14 days.
                        <br />
                        <br />
                        At the end of each Billing cycle, your Subscription will automatically renew. You may cancel it by going to profile or pricing page.
                    </p>
                </article>
                <article>
                    <h2>
                        Free Trial
                    </h2>
                    <p>
                        TubeLink offers a 14 day free trial for customers.
                        <br />
                        <br />
                        You may be required to enter your billing information in order to sign up for the Free Trial.
                        <br />
                        <br />
                        If you do enter your billing information when signing up for the Free Trial, you will not be charged by TubeLink until the Free Trial has expired. On the last day of the Free Trial period, unless you cancelled your Subscription, you will be automatically charged
                    </p>
                </article>
                <article>
                    <h2>
                        Fee Changes
                    </h2>
                    <p>
                        Tubelink processes payment via stripe and by default the payments are set in INR currency in stripe for Tubelink, and for accessiblity of customers, the price can be viewed in USD as well on pricing page, it is using the latest currency exachange rates.
                        <br />
                        <br />

                    </p>
                </article>
                <article>
                    <h2>
                        Contact Us
                    </h2>
                    <p>
                        If you have any questions, please contact us:
                        <br />
                        <br />
                        Contact page: <Link to='/contact' className='contact'>contact</Link>
                        <br />
                        or <a className='email_span' href="mailto:contact.tubelink@gmail.com">
                            contact.tubelink@gmail.com
                        </a>

                        {/* <a className='email_span' href="mailto:email@example.com">
                            shailbandha@gmail.com
                        </a> */}

                    </p>
                </article>
            </main>
            <Footer logout={logout} login={loginUser} user={userAuth} />
        </div>
    )
}

export default Terms